import { t } from '@lingui/core/macro'
import {
  Input,
  Select as SelectCortex,
  SelectMultiOptionsProps,
  SelectOptionsProps,
  SelectRootProps,
  SelectTriggerProps
} from '@tecsinapse/cortex-react'
import React from 'react'

interface SingleSelectProps<T>
  extends SelectOptionsProps<T>,
    Omit<SelectRootProps<T>, 'children'>,
    Omit<SelectTriggerProps, 'onSelect' | 'value'> {
  isMultiSelect?: false
  withSearch?: boolean
  inputSearch?: string
  setInputSearch?: (value: string) => void
}

interface MultiSelectProps<T>
  extends SelectMultiOptionsProps<T>,
    Omit<SelectRootProps<T>, 'children'>,
    Omit<SelectTriggerProps, 'onSelect' | 'value'> {
  isMultiSelect?: true
  withSearch?: boolean
  inputSearch?: string
  setInputSearch?: (value: string) => void
}

type SelectProps<T> = SingleSelectProps<T> | MultiSelectProps<T>

export const Select = <T,>({
  value,
  label,
  labelExtractor,
  options: _options,
  onSelect,
  keyExtractor,
  disabled,
  isMultiSelect,
  withSearch = false,
  inputSearch = '',
  setInputSearch,
  onFocus,
  id,
  className
}: SelectProps<T>) => {
  const options = _options?.filter(opt => {
    const regex = new RegExp(inputSearch, 'i')
    return regex.test(opt.label)
  })

  return (
    <SelectCortex.Root
      value={value}
      keyExtractor={keyExtractor}
      labelExtractor={labelExtractor}
      className={className}
    >
      <SelectCortex.Trigger
        label={label}
        disabled={disabled}
        type={'button'}
        onFocus={onFocus}
        multiLabelSelected={numSelecteds =>
          t`${numSelecteds} itens selecionados`
        }
        id={id}
      />
      <SelectCortex.Popover>
        {withSearch ? (
          <div className='pt-deca px-deca'>
            <Input.Search
              onChange={e => setInputSearch?.(e.target.value)}
              defaultValue={inputSearch}
            />
          </div>
        ) : (
          <></>
        )}
        {isMultiSelect ? (
          <SelectCortex.MultiOptions
            onSelect={onSelect as (value: T[]) => void}
            options={options}
          >
            <SelectCortex.MultiCheckAllOptions
              checkAllLabel={t`Selecionar todos`}
            />
          </SelectCortex.MultiOptions>
        ) : (
          <SelectCortex.Options
            onSelect={onSelect as (value: T) => void}
            options={options}
          />
        )}
      </SelectCortex.Popover>
    </SelectCortex.Root>
  )
}
